import MobileMenu from "~/components/Shared/MobileMenu";
import Preloader from "~/components/Shared/Preloader";
import { getOrder } from "~/helpers/backendHelper";
import NotFound from "~/pages/Error/NotFound";
import React, { useEffect, useState } from "react";
import { To, useNavigate } from "react-router-dom";
import ActionsRow from "./Partial/ActionsRow";
import Contracts from "./Steps/Contracts";
import Sign from "./Steps/Sign";
import { route } from "~/helpers/routeHelper";
import { Row, Col, Container } from "reactstrap";
import menuStepsMobile from "~/constants/menuStepsMobile";

// the e-signature process has 2 steps
const STEP_CONTRACTS = 0; // selecting the contract to sign
const STEP_SIGN = 1; // signing the contract

const MobileContent = () => {

  // router hook that helps redirect
  const navigate = useNavigate();

  /********** STATE **********/

  const [currentStep, setCurrentStep] = useState(STEP_CONTRACTS);
  const [contractId, setContractId] = useState<number | null>(null);
  const [isBusy, setIsBusy] = useState(false);
  const [order, setOrder] = useState(null);
  const [orderError, setOrderError] = useState(false);

  /********** EFFECTS **********/

  // runs once on component mount
  useEffect(() => {
    setIsBusy(true);
    getOrder().then(res => {
      setIsBusy(false);
      if (!res.order || !res.order.isEsignRequired) {
        setOrderError(true);
        return;
      }
      setOrder(res.order)
    }).catch(_err => {
      setIsBusy(false);
      setOrderError(true);
    })
  }, []);

  /********** HANDLERS **********/

  // if we are on the first step of e-signature (selecting the contract)
  // it means that on back, we should redirect the user to the signatures page
  const decreaseStep = () => {
    if (currentStep - 1 < STEP_CONTRACTS) {
      navigate(route('signatures') as To);
    } else {
      setCurrentStep(currentStep - 1);
    }
  }

  /********** OTHER **********/

  // move to the signing step
  const signContract = (id: number) => {
    setContractId(id);
    setCurrentStep(STEP_SIGN);
  }

  // list of steps in the e-sign process
  // each step contains:
  // - component -> the component to render
  // - options -> props sent to that component
  const steps = [
    {
      component: Contracts,
      options: {
        next: signContract,
        order,
        goBack: decreaseStep,
      }
    },
    {
      component: Sign,
      options: {
        id: contractId,
        goBack: decreaseStep,
      }
    }
  ];

  const ActiveStep = steps[currentStep].component;

  return <React.Fragment>
    <div id="signature_mobile_wrapper">
      {order && <>
        <MobileMenu activeStep={menuStepsMobile.ESIGNATURES} />
        <Container className="d-flex justify-content-center">
          <Row className="justify-content-center w-100">
            <Col md={9} lg={6} xl={5} className="p-0">
              <ActionsRow back={decreaseStep} />
              <ActiveStep {...(steps[currentStep].options as any)} />
            </Col>
          </Row>
        </Container>
      </>
      }
      {isBusy && <Preloader />}
      {orderError && <NotFound />}
    </div>
  </React.Fragment>
}

export default MobileContent;
